import { TranslationFile } from 'i18n'
import { useTranslation } from 'react-i18next'

import appConfig from 'app.config'
import { IApplicationInformation } from 'interfaces/i-application-information'

export const UpdateSpouseFormLt = (data: IApplicationInformation) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
		TranslationFile.Countries,
	])

	return {
		fieldSetName: '',
		formName: 'updateSpouseForm',
		description: t('forms:UpdateSpouseDescription'),
		collapsable: false,
		show: true,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'ssn',
				type: 'text',
				label: t('forms:SSN'),
				value: data?.spouse?.ssn,
				visible: true,
				disabled: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'firstName',
				type: 'text',
				label: t('forms:FirstName'),
				value: data?.spouse?.firstName,
				visible: true,
				disabled: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'lastName',
				type: 'text',
				label: t('forms:LastName'),
				value: data?.spouse?.lastName,
				visible: true,
				disabled: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'email',
				type: 'text',
				label: t('forms:Email'),
				value: data.spouse?.email,
				visible: true,
				disabled: true,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '\\S+@\\S+\\.\\S+',
						message: t('ValidationMsgEmail'),
					},
				],
				col: 12,
			},
			{
				required: true,
				controlName: 'mobilePhoneNumber',
				type: 'tel', //change back to phoneNumber
				label: t('forms:MobilePhoneNo'),
				value: data.spouse?.cellPhone,
				visible: true,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^\\+370\\s?6[0-9]{7}$',
						message: t('ValidationMsgMobilePhone'),
					},
				],
				col: 12,
				wrapperClass: 'tel-container-wrapper lt', //Add this class for now when using type "tel"
			},
			{
				required: false,
				controlName: 'monthlyIncome',
				type: 'number',
				label: t('forms:MonthlyIncome'),
				value: data.spouse?.monthlyIncome,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^[0-9]*$',
						message: t('forms:ValidationMsgValue'),
					},
				],
				visible: true,
				col: 12,
			},
			{
				required: false,
				controlName: 'reducedIncome',
				type: 'checkbox',
				label: t('forms:ReducedIncome'),
				value: false,
				visible: true,
				col: 12,
			},
			{
				required: false,
				controlName: 'expectedFutureIncome',
				type: 'number',
				label: t('forms:ExpectedFutureIncome'),
				value: 0,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^[0-9]*$',
						message: t('forms:ValidationMsgValue'),
					},
				],
				visible: false,
				col: 12,
			},
			{
				required: false,
				controlName: 'mortgageMonthlyCost',
				type: 'number',
				label: t('forms:MortgageMonthlyCost'),
				value: data.spouse?.mortgageMonthlyCost,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^[0-9]*$',
						message: t('forms:ValidationMsgValue'),
					},
				],
				visible: true,
				col: 12,
			},
			{
				required: false,
				controlName: 'missedObligations',
				type: 'number',
				label: t('forms:MissedObligations'),
				value: data.spouse?.missedObligations,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^[0-9]*$',
						message: t('forms:ValidationMsgValue'),
					},
				],
				visible: true,
				col: 12,
			},
			{
				required: false,
				controlName: 'otherMonthlyCost',
				type: 'number',
				label: t('forms:LoansOtherMonthlyCost'),
				value: data.spouse?.otherMonthlyCost,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^[0-9]*$',
						message: t('forms:ValidationMsgValue'),
					},
				],
				visible: true,
				col: 12,
			},
			{
				options: [
					{
						value: false,
						label: t('No'),
					},
					{
						value: true,
						label: t('Yes'),
					},
				],
				required: true,
				controlName: 'pep',
				type: 'dropdown',
				label: t('forms:PoliticallyExposedPerson'),
				tooltip: t('forms:PEPInfoDescription'),
				value: data.spouse?.pep,
				visible: true,
				col: 12,
			},
			{
				required: false,
				controlName: 'allowMarketing',
				type: 'checkbox',
				label: t('forms:AllowMarketing'),
				value: data.spouse?.allowMarketing,
				visible: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'processDataConsent',
				type: 'checkbox',
				label: t('forms:ProcessDataConsent'),
				value: data.spouse?.processDataConsent,
				visible: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'privacyPolicy',
				type: 'checkbox',
				label: t('forms:PrivacyPolicy'),
				value: false,
				visible: true,
				col: 12,
			},
		],
	}
}
